var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJoinFullOuter = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 11.873a4.75 4.75 0 1 1 0-7.747 4.75 4.75 0 0 0 0 7.747zm0 0c1.21-.86 2-2.275 2-3.873 0-1.598-.79-3.013-2-3.873a4.75 4.75 0 1 1 0 7.747z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.75 8c0 1.144.48 2.176 1.25 2.905A3.989 3.989 0 0 0 9.25 8c0-1.144-.48-2.176-1.25-2.905A3.989 3.989 0 0 0 6.75 8z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgJoinFullOuter);
export default ForwardRef;